export const REACT_APP_OZK_VESTING = process.env.REACT_APP_OZK_VESTING
export const REACT_APP_OZK_VESTING_TOKEN = process.env.REACT_APP_OZK_VESTING_TOKEN
export const REACT_APP_OZK_FUND = process.env.REACT_APP_OZK_FUND
export const REACT_APP_USDT_TOKEN = process.env.REACT_APP_USDT_TOKEN
export const REACT_APP_RPC_URL = process.env.REACT_APP_RPC_URL
export const REACT_APP_BUY_TOKEN = process.env.REACT_APP_BUY_TOKEN
export const REACT_APP_BUY_USD_TOPIC0 = process.env.REACT_APP_BUY_USD_TOPIC0
export const REACT_APP_WITHDRAW_TOPIC0 = process.env.REACT_APP_WITHDRAW_TOPIC0
export const REACT_APP_ADMIN_WITHDRAW_ETH_TOPIC0= process.env.REACT_APP_ADMIN_WITHDRAW_ETH_TOPIC0
export const REACT_APP_BUY_ETH_TOPIC0 = process.env.REACT_APP_BUY_ETH_TOPIC0
export const REACT_APP_VESTED_TOPIC0 = process.env.REACT_APP_VESTED_TOPIC0
export const REACT_APP_ADMIN_FUND_WITHDRAW = process.env.REACT_APP_ADMIN_FUND_WITHDRAW
export const REACT_APP_ADMIN_ETHFUND_WITHDRAW = process.env.REACT_APP_ADMIN_ETHFUND_WITHDRAW
export const REACT_APP_ADMIN_WHITELIST_ROLE = process.env.REACT_APP_ADMIN_WHITELIST_ROLE
export const REACT_APP_PRIVATE_SALE = process.env.REACT_APP_PRIVATE_SALE
export const REACT_APP_FUNDS_OWNER_ROLE = process.env.REACT_APP_FUNDS_OWNER_ROLE
export const REACT_APP_ADMIN_ROLE = process.env.REACT_APP_ADMIN_ROLE

export const REACT_APP_ETH_API_URL = process.env.REACT_APP_ETH_API_URL
export const REACT_APP_TRANSACTION_HASHLINK = process.env.REACT_APP_TRANSACTION_HASHLINK
export const REACT_APP_API_KEY = process.env.REACT_APP_API_KEY

export const REACT_APP_PRICE_FEED_DECIMALS = parseInt(process.env.REACT_APP_PRICE_FEED_DECIMALS, 10)
export const REACT_APP_USDT_DECIMALS = parseInt(process.env.REACT_APP_USDT_DECIMALS, 10)

export const REACT_APP_CHAIN_ID = process.env.REACT_APP_CHAIN_ID

export const REACT_APP_APPLICATION_URL = process.env.REACT_APP_APPLICATION_URL

export const REACT_APP_PROJECT_ID = process.env.REACT_APP_PROJECT_ID

export const REACT_APP_START_BLOCK = process.env.REACT_APP_START_BLOCK

export const REACT_APP_WHITELIST_START_DATE = process.env.REACT_APP_WHITELIST_START_DATE
export const REACT_APP_PRESALE_START_DATE = process.env.REACT_APP_PRESALE_START_DATE
export const REACT_APP_PRESALE_END_DATE = process.env.REACT_APP_PRESALE_END_DATE
